export const isPriceEvolutionRateStale = (
  rate: number | null,
  updatedAt: string | null,
  now: Date,
): boolean => {
  if (rate == null) {
    return false;
  }

  const timestamp = updatedAt ? new Date(updatedAt).getTime() : NaN;
  const startOfMonth = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), 1);
  const endOfMonth = Date.UTC(now.getUTCFullYear(), now.getUTCMonth() + 1, 1);

  return !(
    Number.isFinite(timestamp) &&
    timestamp >= startOfMonth &&
    timestamp < endOfMonth
  );
};
